module.exports = __webpack_public_path__ + "static/media/aerovinum-4.795891b2.jpg";